import { Box, Stack, Typography, useTheme } from "@mui/material";
import { LocalizationContext } from "../localization/context.js";
import { makeCurrencyFormatter, price } from "./utils.js";
import { NumberOfPlayersChip } from "./number-of-players-chip.js";
import { useMediaQuery } from "../utilities/index.js";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import React from "react";
export const SingleProduct = ({ hover = true, imageAlt, imageTitle, path, product, showPlayerInfo = true, showPrice = true, sizes = "33vw", }) => {
    const { t } = useTranslation(["c-product", "c-common"]);
    const theme = useTheme();
    const { colors, coverImage, edition, slug, title } = product;
    const isTouchDevice = useMediaQuery("(hover: none)");
    const categoryPath = edition === "online" ? t("c-common:slug-online") : t("c-common:slug-print");
    const { market } = React.useContext(LocalizationContext);
    const { amount, currency } = price({ product, market });
    const formatCurrency = makeCurrencyFormatter({ currency });
    const IMAGE_STYLES = {
        backgroundColor: edition === "online" ? "unset" : colors.primary,
        borderRadius: "12px",
        overflow: "visible",
        transform: "translateZ(0)",
        "&:hover": {
            a: {
                opacity: 1,
                transform: !hover || isTouchDevice ? "translateZ(0)" : "scale(1.03) translateZ(0)",
                ...(!hover || isTouchDevice
                    ? {}
                    : {
                        boxShadow: edition === "online" ? "none" : "productHover",
                        filter: edition === "online" ? "drop-shadow(22.3px 22.3px 17.9px rgba(0, 0, 0, 0.125))" : "none",
                    }),
            },
        },
        a: {
            "&:hover": { opacity: 1 },
            borderRadius: "12px",
            boxShadow: edition === "online" ? "none" : "product",
            display: "flex",
            filter: edition === "online" ? "drop-shadow(12.5px 3.1px 10px rgba(0, 0, 0, 0.2))" : "none",
            height: "auto",
            img: {
                height: "auto",
                maxWidth: "100%",
                width: "100%",
                transform: "translateZ(0)",
            },
            maxWidth: "100%",
            transform: "translateZ(0)",
            transition: theme.transitions.create(["box-shadow", "filter", "transform"]),
            width: "100%",
        },
    };
    return (React.createElement(Stack, { direction: "column", spacing: 3 },
        React.createElement(Box, { className: "image-container", sx: IMAGE_STYLES },
            React.createElement(Link, { href: path ?? `/${categoryPath}/${slug}` },
                React.createElement(Image, { alt: imageAlt ?? title, sizes: sizes, title: imageTitle ?? title, ...coverImage }))),
        (showPlayerInfo || showPrice) && (React.createElement(Box, { sx: { alignItems: "center", display: "flex", flexDirection: "column" } },
            showPlayerInfo && React.createElement(NumberOfPlayersChip, { product: product }),
            showPrice && (React.createElement(Stack, { alignItems: "baseline", direction: "row", spacing: 1, sx: { mt: 0.75 } },
                React.createElement(Typography, { variant: "body2", sx: { pt: 0, pb: 0 } }, formatCurrency(amount)),
                React.createElement(Typography, { variant: "caption" }, t("c-product:inclusive-vat", "inkl. MwSt."))))))));
};
//# sourceMappingURL=single-product.js.map